// The sheet a Setup divider opens in an editable plan: how long this one setup
// runs, or skip it. Setups are placed by the app (transitionInjector), between
// blocks, and re-placed after every edit, so there is nothing to drag or add —
// only the length and whether this boundary gets one at all.
//
// Changes apply as they are made, like every DetailSheet; Done only closes.

import React from "react";
import DetailSheet from "../session/generate/DetailSheet";
import DraggableStepper from "../ui/draggable-stepper";
import { Button } from "../ui/button";
import { toSeconds } from "../../utils/time";

const SetupSheet = ({ node, onOpenChange, onChangeSeconds, onSkip }) => {
  const seconds = node ? toSeconds(node.value, node.unit) : 0;
  return (
    <DetailSheet
      open={!!node}
      onOpenChange={onOpenChange}
      title="Setup"
      description="Time to move and set up your kit before the next block. Setups sit between blocks by themselves and follow them when you move one."
      showDescription
    >
      <div className="space-y-4">
        <DraggableStepper
          label="Length"
          value={seconds}
          onChange={(v) => onChangeSeconds(v)}
          min={5}
          max={300}
          step={5}
          unit="s"
          prominent
        />
        <Button
          type="button"
          variant="ghost"
          className="h-11 w-full justify-start px-0 text-base text-destructive hover:bg-transparent hover:text-destructive"
          onClick={onSkip}
        >
          Skip this setup
        </Button>
      </div>
    </DetailSheet>
  );
};

export default SetupSheet;
